import { DonutStatusTag } from "@/pages/catalogs/pages/donuts/components/DonutStatusTag";
import { RollStatusTag } from "@/pages/catalogs/shared/components/RollStatusTag";
import { Autocomplete, Box, TextField } from "@mui/material";
import { FieldError } from "react-hook-form";

export const donutStatusCodes = [
	{ Code: "R", Name: "Ready", Color: "#009460" },
	{ Code: "U", Name: "Under Repair", Color: "#fad215" },
	{ Code: "D", Name: "Damaged", Color: "#ce2029" },
];

type Props = {
	label: string;
	value: string | null;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
	required?: boolean;
};

export const DonutStatusSelector = ({
	label,
	value,
	onChange = () => {},
	fieldError,
	disabled = false,
	required = false,
}: Props) => {
	const selectedStatus =
		donutStatusCodes.find((code) => code.Code === value) || null;

	return (
		<Autocomplete
			clearOnEscape
			autoHighlight
			options={donutStatusCodes}
			getOptionLabel={(option) => option.Name}
			renderOption={(props, option) => (
				<Box
					{...props}
					component="li"
					sx={{
						display: "flex",
						alignItems: "center",
					}}
				>
					<span
						style={{
							width: "25px",
							height: "25px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							marginRight: "8px",
							marginLeft: "8px",
						}}
					>
						<DonutStatusTag
							status={{
								Code: option.Code,
								Name: option.Name,
							}}
						/>
					</span>
					{option.Name}
				</Box>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					required={required}
					label={label}
					variant="outlined"
					fullWidth
					error={!!fieldError}
					helperText={fieldError?.message}
					size="small"
					inputProps={{
						...params.inputProps,
						"data-test-id": "donut-status-selector",
					}}
					InputProps={{
						...params.InputProps,
						startAdornment: value ? (
							<span
								style={{
									width: "25px",
									height: "25px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									marginRight: "8px",
									marginLeft: "8px",
								}}
							>
								<DonutStatusTag
									status={{
										Code: selectedStatus?.Code ?? "",
										Name: selectedStatus?.Name ?? "",
									}}
								/>
							</span>
						) : null,
					}}
				/>
			)}
			value={selectedStatus}
			onChange={(event, newValue) => {
				onChange(newValue?.Code ?? null);
			}}
			disabled={disabled}
		/>
	);
};
